import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import {TicketDto} from '../type/dtos/Ticket';
import {PaginatedResponse} from '../../types/api';
import {TicketFlowDto} from '../type/dtos/TicketFlow';

export default {
    namespace: 'ticket',

    state: {
        tickets: undefined,
        ticketsOrder: undefined,
        ticketsGroup: undefined,
    },

    effects: (dispatch: any) => ({
        fetchTickets(query: string = '') {
            return actionWrapper(
                 () => axios.get(`ticketing${query}`)
                     .then((res) => {
                         dispatch.ticket.fetchTickets_reducer(res?.data);
                         return res;
                     }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        saveTicket(data: TicketDto) {
            return actionWrapper(
                 () => axios.post('ticketing', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        saveTicketFlow(data: TicketFlowDto) {
            return actionWrapper(
                 () => axios.post('ticketing/ticketFlow', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        fetchTicketsOrder(id: number) {
            return actionWrapper(
                () => axios.get(`ticketing/order/${id}`)
                    .then((res) => {
                        dispatch.ticket.fetchTicketsOrder_reducer(res?.data);
                        return res;
                    })
                    .catch((err) => {
                        dispatch.ticket.fetchTicketsOrder_reducer(null);
                        return err;
                    }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        fetchTicketsGroup() {
            return actionWrapper(
                () => axios.get('ticketing/groups')
                    .then((res) => {
                        dispatch.ticket.fetchTicketsGroup_reducer(res?.data);
                        return res;
                    })
                    .catch((err) => {
                        dispatch.ticket.fetchTicketsGroup_reducer(null);
                        return err;
                    }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
    }),

    reducers: {
        fetchTickets_reducer(state: any, payload: PaginatedResponse<TicketDto>) {
            return {...state, tickets: payload};
        },
        fetchTicketsOrder_reducer(state: any, payload: TicketDto[]) {
            return {...state, ticketsOrder: payload};
        },
        fetchTicketsGroup_reducer(state: any, payload: string[]) {
            return {...state, ticketsGroup: payload};
        },
    },
};
